import React, { useEffect, useRef, useState } from 'react';
import FlashingDot from './FlashingDot';
import EighthNoteAnimated from "../images/notes/EighthNoteAnimated";
import DoubleNoteAnimated from "../images/notes/DoubleNoteAnimated";
import { CopyrightCircleFilled, PictureFilled } from '@ant-design/icons';
import Credits from './Credits';
import { FloatButton, Tour } from 'antd';
import { FaMapSigns } from 'react-icons/fa';

const MainMenu = ({ setActiveCamera, cameras, trackedObjects, isMobile, firstLoad }) => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);

  const [tourOpen, setTourOpen] = useState(firstLoad);

  const steps = [
    {
      title: 'Welcome to my room!',
      description: 'Click on the flashing dots to explore different areas of my room.',
      target: () => ref1.current
    },
    {
      title: 'Vinyl Collection',
      description: 'Click on the vinyl to learn more about my music collection.',
      target: () => ref2.current
    },
    {
      title: 'Desk',
      description: 'Click on the desk to see my work setup and projects.',
      target: () => ref3.current
    },
    {
      title: 'Degrees',
      description: 'Click on the degrees to see my academic path.',
      target: () => ref4.current
    },
    {
      title: 'Trophy Case',
      description: 'Click on the thophies to see my software skills.',
      target: () => ref5.current
    },
    {
      title: 'TV',
      description: 'Click on the TV to see some of my hobbies.',
      target: () => ref6.current
    },
    {
      title: 'Static Room',
      description: <>Click on the <PictureFilled /> button to switch to the static room</>,
      target: () => ref7.current
    }
  ];

  const [areNotesVisible, setAreNotesVisible] = useState(false);
  const [areCreditsVisible, setAreCreditsVisible] = useState(false);

  const [vinyl, setVinyl] = useState(null);
  const [bottle, setBottle] = useState(null);
  const [trophy, setTrophy] = useState(null);
  const [degree, setDegree] = useState(null);
  const [tv, setTv] = useState(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAreNotesVisible(true);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    setVinyl(trackedObjects.find(o => o.name === 'record-player-spindle'));
    setBottle(trackedObjects.find(o => o.name === 'bottle'));
    setTrophy(trackedObjects.find(o => o.name === 'problem-solving-stand'));
    setDegree(trackedObjects.find(o => o.name === 'bachelor-frame'));
    setTv(trackedObjects.find(o => o.name === 'declan-rice'));
  }, [trackedObjects]);


  return (
    <>
      {vinyl && <FlashingDot ref={ref2} onClick={setActiveCamera} param={cameras[isMobile ? process.env.REACT_APP_VINYL_CAMERA_MOBILE : process.env.REACT_APP_VINYL_CAMERA]} position={{ x: vinyl.pos.x, y: vinyl.pos.y }}/>}
      {bottle && <FlashingDot ref={ref3} onClick={setActiveCamera} param={cameras[isMobile ? process.env.REACT_APP_DESK_CAMERA_MOBILE : process.env.REACT_APP_DESK_CAMERA]} position={{ x: bottle.pos.x, y: bottle.pos.y }}/>}
      {trophy && <FlashingDot ref={ref5} onClick={setActiveCamera} param={cameras[isMobile ? process.env.REACT_APP_SKILL_CAMERA_MOBILE : process.env.REACT_APP_SKILL_CAMERA]} position={{ x: trophy.pos.x, y: trophy.pos.y }}/>}
      {degree && <FlashingDot ref={ref4} onClick={setActiveCamera} param={cameras[isMobile ? process.env.REACT_APP_DEGREE_CAMERA_MOBILE : process.env.REACT_APP_DEGREE_CAMERA]} position={{ x: degree.pos.x, y: degree.pos.y }}/>}
      {tv && <FlashingDot ref={ref6} onClick={setActiveCamera} param={cameras[isMobile ? process.env.REACT_APP_TV_CAMERA_MOBILE : process.env.REACT_APP_TV_CAMERA]} position={{ x: tv.pos.x, y: tv.pos.y }}/>}
      {areNotesVisible && vinyl && (
        <>
          <DoubleNoteAnimated begin={0.3} scale={0.2} duration={3} color={'white'} position={{ x: vinyl.pos.x - 30, y: vinyl.pos.y - 240 }} />
          <EighthNoteAnimated begin={0.5} scale={0.4} duration={3.5} color={'white'} position={{ x: vinyl.pos.x, y: vinyl.pos.y - 170  }} />
          <EighthNoteAnimated begin={0.5} scale={0.2} duration={3} color={'white'} position={{ x: vinyl.pos.x, y: vinyl.pos.y - 120  }} />
        </>
      )}
      {areNotesVisible && (<Credits isModalOpen={areCreditsVisible} setIsModalOpen={setAreCreditsVisible} />)}
      {vinyl && bottle && trophy && degree && tv && <Tour open={tourOpen} onClose={() => setTourOpen(false)} steps={steps} />}
      <FloatButton
        icon={<CopyrightCircleFilled />}
        tooltip='Credits'
        style={{
          insetInlineEnd: 94,
        }}
        onClick={() => setAreCreditsVisible(true)}
      />
      <FloatButton.Group style={{insetInlineEnd: 94,}} >
        <FloatButton ref={ref1} icon={<FaMapSigns />} tooltip='Guide' onClick={() => setTourOpen(true)} />
        <FloatButton icon={<CopyrightCircleFilled />} tooltip='Credits' onClick={() => setAreCreditsVisible(true)} />
      </FloatButton.Group>
    </>
  );
};

export default MainMenu;